// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1EPb1","header":"Messages_header__3XOHR"};